/**
 * mh-session.js
 * Reads the MenaHub localStorage session and updates the header user menu
 * so the correct state (guest vs logged-in) is always shown — even when
 * Shopify's native customer session is not set (New Customer Accounts blocks
 * the activation URL flow).
 */
(function () {
  'use strict';

  var TOKEN_KEY = 'mh_token';
  var USER_KEY  = 'mh_user';

  function getSession() {
    try {
      var token = localStorage.getItem(TOKEN_KEY);
      var user  = JSON.parse(localStorage.getItem(USER_KEY) || 'null');
      if (token && user) return { token: token, user: user };
    } catch (e) {}
    return null;
  }

  function clearSession() {
    try {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    } catch (e) {}
  }

  function applySession(session) {
    // Show logged-in items, hide guest items
    document.querySelectorAll('[data-mh-auth]').forEach(function (el) {
      el.style.display = '';
    });
    document.querySelectorAll('[data-mh-guest]').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function applyGuest() {
    // Show guest items, hide logged-in items
    document.querySelectorAll('[data-mh-auth]').forEach(function (el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('[data-mh-guest]').forEach(function (el) {
      el.style.display = '';
    });
  }

  function bindLogout() {
    document.querySelectorAll('[data-mh-logout]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        // If this is our custom logout link (href="#"), handle it ourselves
        if (el.getAttribute('href') === '#') {
          e.preventDefault();
          clearSession();
          window.location.href = '/';
        }
        // If Shopify's logout URL is set, let the native link fire (it also
        // clears the Shopify session), but clear localStorage first
        clearSession();
      });
    });
  }

  function init() {
    var session = getSession();
    if (session) {
      applySession(session);
    } else {
      applyGuest();
    }
    bindLogout();
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
